import { EMBER_ROUTE_NAMES } from "../routes";

export const PROJECTS_DASHBOARD_APPLICATION_SUMMARY_INCLUDES = [
  'company-team',
];

/**
 * The number of projects we'll retrieve per page.
 *
 * @type {number}
 */
export const PROJECTS_PER_PAGE = 10;

/**
 * Number of characters we'll allow before sending a request.
 *
 * @type {number}
 */
export const PROJECTS_SEARCH_CHARACTERS_BEFORE_REQUEST = 1;

/**
 * The human readable 'application' sort options
 *
 * @type {Object}
 */
export const PROJECTS_SORT_OPTIONS = {
  LAST_ACTIVITY: 'Last activity',
  DATE_STARTED: 'Date started',
  POSTING_NAME: 'Posting name',
  UNREAD_MESSAGES: 'Unread messages',
};

/**
 * API Enum strings that we'll be passing down to the api for the sort
 *
 * @type {Object}
 */
export const PROJECTS_SORT_API_ENUMS = {
  LAST_ACTIVITY: 'last-activity',
  DATE_STARTED: 'date-started',
  POSTING_NAME: 'posting-name',
  UNREAD_MESSAGES: 'unread-messages',
};

/**
 * The navigation titles for the Projects View e.g. projects/in-progress and etc.
 *
 * @type {Object}
 */
export const PROJECTS_NAV_TITLES = {
  IN_PROGRESS: 'In Progress',
  COMPLETE: 'Complete',
  CANCELLED: 'Cancelled'
};

/**
 * Map of ProjectNavTitle => Ember Route Name for that nav title
 *
 * @type {Object}
 */
export const PROJECTS_NAV_TITLES_TO_ROUTES_MAP = {
  [PROJECTS_NAV_TITLES.IN_PROGRESS] : EMBER_ROUTE_NAMES.PROJECTS__IN_PROGRESS,
  [PROJECTS_NAV_TITLES.COMPLETE] : EMBER_ROUTE_NAMES.PROJECTS__COMPLETE,
  [PROJECTS_NAV_TITLES.CANCELLED] : EMBER_ROUTE_NAMES.PROJECTS__CANCELLED
};

/**
 * The human readable strings for the project's 'network' filter options
 *
 * @type {Object}
 */
export const PROJECTS_NETWORK_FILTER_OPTIONS = {
  POSTED_BY_ANYONE: 'Posted by anyone',
  POSTED_BY_YOU: 'Posted by you',
  POSTED_BY_OTHERS: 'Posted by others'
};

/**
 * The human readable strings for the postings 'company team' filter options
 *
 * @type {Object}
 */
export const PROJECTS_COMPANY_TEAM_FILTER_OPTIONS = {
  ALL_TEAMS: 'All Teams',
};

/**
 * API Enum strings that we'll be passing down to the api for the 'network' filter
 *
 * @type {Object}
 */
export const PROJECTS_NETWORK_FILTER_API_ENUMS = {
  POSTED_BY_ANYONE: 'all',
  POSTED_BY_YOU: 'me',
  POSTED_BY_OTHERS: 'others'
};
